/* stop iframe video - general functions */
export function modalsStopVideo ( video_modals ) {

    video_modals.forEach((v_element) => {
        v_element.addEventListener('hidden.bs.modal', function (event) {
            // stop video on close
            var iframe = v_element.querySelector( 'iframe');
            var video = v_element.querySelector( 'video' );
            if ( iframe ) {
                var iframeSrc = iframe.src;
                iframe.src = iframeSrc;
            }
            if ( video ) {
                video.pause();
            }
        });
    });
}

/* External Link */
var links = document.links;

for (var i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname != window.location.hostname) {
    links[i].target = '_blank';
  } 
}